export enum ClaimFormSteps {
  GettingStarted,
  Consumer,
  ConsumerAgreement,
  Products,
  SubmitterAndEscalation,
  PhotosAndDocuments,
}
